import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { child, get, ref, update } from "firebase/database";
import { isBeta } from "../../AdminConfig";
import { GetSubscriptionSetData } from "../../Api/ServiceDatas";
import LineBtn from "../../components/Button/LineBtn";
import ToggleBtn from "../../components/Button/ToggleBtn";
import Flex from "../../components/DefaultStyles/Flex";
import LineBox from "../../components/DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { database } from "../../components/fBase";
import loginCheckLoginTypeData from "../../AdminApi/loginCheck_set.json";
import Loader from "../../components/DefaultStyles/Loader";
import dayjs from "dayjs";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { authType } from "../Login";
import ReportLimitCntBtn from "../../components/pages/Manage/LoginCheck/ReportLimitCntBtn";
import { useApi } from "../../hooks/useApi";
import { validCheckTabState } from "../../components/pages/Manage/ValidCheck/ValidCheckTab";
import LoginCheckAllToagleBtn from "../../components/pages/Manage/ValidCheck/ManageLoginCheck/LoginCheckAllToagleBtn";
import { GetSubscriptionSetData_V3 } from "../../ApiTS/ServiceDatasTS_V3";
import { getSubsNameBySubsId3 } from "../../AdminApi/3.0_utils";

interface SUseText {
  check?: boolean;
}

export const validCheckSubsIdState = atom<number>({
  key: "validCheckSubsIdState",
  default: 0,
});

export default function LoginCheck() {
  const auth = useRecoilValue(authType);

  const [isLoading, setIsLoading] = useState(false);
  const [loginCheckData, setLoginCheckData] = useState<any>();
  const [reportLimitCnt, setReportLimitCnt] = useState(0);

  const setSubsId = useSetRecoilState(validCheckSubsIdState);
  const setValidCheck = useSetRecoilState(validCheckTabState);

  const LoginCheckHeader = [
    "Subscription",
    "로그인 타입",
    "로그인 체커 사용 (APP)",
    "로그인 체커 사용 (WEB)",
    "마지막 신고 일시",
    "신고된 파티",
  ];

  const dbRef = ref(database, isBeta ? "Beta/LoginChk" : "Live/LoginChk");

  // 마지막 신고 일시
  const { response, loading } = useApi({
    method: "get",
    url: `temp-account/listErrParty?page=0&size=10&subsid=1`,
  });

  const getLastUpdateDate = (subsId: number) => {
    const data = response?.data?.find(
      (a: { subsid: number; timestamp: number }) => {
        return a.subsid === subsId;
      }
    );

    return data?.updatedate;
  };

  // loginCheck 가져오기
  const getLoginCheckData = async () => {
    setIsLoading(true);

    await get(dbRef).then((snapshot) => {
      let subsList = [];

      setReportLimitCnt(snapshot.val()?.reportLimitCnt);

      let result = Object.entries(snapshot.val());

      subsList.push(snapshot.val());

      setLoginCheckData(result?.slice(0, -1));

      setIsLoading(false);
    });
  };

  // 로그인 체커 사용 toggle
  const toggleLoginCheck = async (
    subsid: string,
    nowState: boolean,
    isApp: boolean
  ) => {
    const subsIdRef = child(dbRef, subsid);

    try {
      return await update(
        subsIdRef,
        isApp
          ? {
              useApp: !nowState,
              reportCnt: 0,
            }
          : {
              use: !nowState,
              reportCnt: 0,
            }
      );
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  useEffect(() => {
    setSubsId(0);
  }, []);

  useEffect(() => {
    if (auth?.adminLog) {
      getLoginCheckData();
    }
  }, [auth?.adminLog]);

  return (
    <>
      <LoginCheckContainer>
        <Flex
          style={{ justifyContent: "flex-end", marginBottom: 12 }}
          gapSize={10}
        >
          <LoginCheckAllToagleBtn
            getLoginCheckData={getLoginCheckData}
            toggleLoginCheck={toggleLoginCheck}
            loginCheckData={loginCheckData}
          />

          <ReportLimitCntBtn
            reportLimitCnt={reportLimitCnt}
            getLoginCheckData={getLoginCheckData}
          />
        </Flex>

        <LineBox>
          <Table tableHeadData={LoginCheckHeader} tableMinWidth={600}>
            <>
              {loginCheckData?.map((d: any, index: number) => {
                const subsId = d[0];
                const data = d[1];

                const loginType = loginCheckLoginTypeData?.find(
                  (data) => data?.subsId === Number(subsId)
                )?.loginType;

                const lastReportItem: any = Object.values(
                  data?.reportPid ?? {}
                )[Object.values(data?.reportPid ?? {}).length - 1];

                return (
                  <TableBody key={Number(subsId)}>
                    <TableBodyItem>
                      {subsId}_{getSubsNameBySubsId3(Number(subsId))}
                    </TableBodyItem>
                    <TableBodyItem>
                      {loginType === "" || loginType === undefined
                        ? "-"
                        : loginType}
                    </TableBodyItem>

                    <TableBodyItem>
                      <Flex gapSize={8}>
                        <ToggleBtn
                          check={data?.useApp}
                          checkEvent={() =>
                            toggleLoginCheck(subsId, data?.useApp, true).then(
                              () => {
                                getLoginCheckData();
                              }
                            )
                          }
                        />

                        <UseText check={data?.useApp}>
                          {data?.useApp ? "ON" : "OFF"}
                        </UseText>
                      </Flex>
                    </TableBodyItem>

                    <TableBodyItem>
                      <Flex gapSize={8}>
                        <ToggleBtn
                          check={data?.use}
                          checkEvent={() =>
                            toggleLoginCheck(subsId, data?.use, false).then(
                              () => {
                                getLoginCheckData();
                              }
                            )
                          }
                        />

                        <UseText check={data?.use}>
                          {data?.use ? "ON" : "OFF"}
                        </UseText>
                      </Flex>
                    </TableBodyItem>

                    <TableBodyItem>
                      {getLastUpdateDate(+subsId)
                        ? dayjs(getLastUpdateDate(+subsId)).format(
                            "YYYY-MM-DD HH:mm"
                          )
                        : "-"}
                    </TableBodyItem>

                    <TableBodyItem>
                      <LineBtn
                        btnText="조회"
                        btnClickEvent={() => {
                          setSubsId(+subsId);
                          setValidCheck(1);
                        }}
                        disabled={!getLastUpdateDate(+subsId)}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              })}
            </>
          </Table>
        </LineBox>
      </LoginCheckContainer>

      {(isLoading || loading) && <Loader />}
    </>
  );
}

const LoginCheckContainer = styled.div`
  width: 100%;
`;

const UseText = styled.span<SUseText>`
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  color: ${({ check, theme }) =>
    check ? theme.buttonColor.blueNormal : theme.buttonColor.lineHover};
`;
